class ProgrammePdf extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Le custom element EST le bouton (voir main-product.liquid)
    // Donc on attache l'écouteur directement sur 'this'
    this.addEventListener('click', this.handleDownload.bind(this));
  }

  cleanContent(htmlContent) {
    if (!htmlContent) return '';
    
    // Créer un élément temporaire pour manipuler le DOM
    const div = document.createElement('div');
    div.innerHTML = htmlContent;

    // Remplacer les iframes YouTube par des liens
    const iframes = div.querySelectorAll('iframe');
    iframes.forEach(iframe => {
        let src = iframe.src;
        if (src) {
            // Transformer l'URL embed en URL watch si c'est du YouTube
            // Ex: https://www.youtube.com/embed/VIDEO_ID -> https://www.youtube.com/watch?v=VIDEO_ID
            if (src.includes('youtube.com/embed/')) {
                const videoId = src.split('embed/')[1]?.split('?')[0];
                if (videoId) {
                    src = `https://www.youtube.com/watch?v=${videoId}`;
                }
            }

            // Créer un lien de remplacement
            const link = document.createElement('div');
            link.className = 'video-replacement-card';
            
            link.innerHTML = `
                <a href="${src}" target="_blank" class="video-replacement-link">
                    ▶ Voir la vidéo associée (Lien externe)
                </a>
            `;
            
            iframe.parentNode.replaceChild(link, iframe);
        }
    });

    return div.innerHTML;
  }

  async handleDownload(e) {
    e.preventDefault();
    e.stopPropagation();

    // 1. Récupérer les données depuis le script JSON interne
    const jsonScript = this.querySelector('script[type="application/json"]');
    if (!jsonScript) {
        alert("Erreur : Données de formation introuvables.");
        return;
    }

    let data;
    try {
        data = JSON.parse(jsonScript.textContent);
    } catch (err) {
        alert("Erreur de lecture des données.");
        return;
    }

    const { title, reference, sections, modalities, duration, price } = data;
    
    // Logo statique (hauteur augmentée pour meilleure qualité PDF)
    const logo = "https://cdn.shopify.com/s/files/1/0872/7933/7805/files/20220529211037-logo-ofibfr_b8c908b4-3397-46d6-83c8-c2f08c6d686b.png?v=1765214231&height=240";
    
    // Bloc d'informations (Durée, Modalité, Prix)
    const infosHtml = `
      <div class="info-card">
        ${modalities ? `
        <div class="info-column">
            <div class="info-label">Modalités</div>
            <div class="info-value">${modalities}</div>
        </div>` : ''}
        ${duration ? `
        <div class="info-column with-border">
            <div class="info-label">Durée</div>
            <div class="info-value">${duration}</div>
        </div>` : ''}
        ${price ? `
        <div class="info-column with-border">
            <div class="info-label">Prix</div>
            <div class="info-value price">${price}</div>
        </div>` : ''}
      </div>
      <div class="price-disclaimer">
        Les prix affichés sont en euros, hors taxes (HT). La TVA sera ajoutée au moment de la commande, selon le taux en vigueur.
      </div>
    `;

    // 2. Construire le contenu des sections
    const sectionsHtml = sections
        .filter(section => section.content && section.content.trim() !== '')
        .map(section => {
            // Générer une classe CSS unique à partir du titre de la section
            const sectionClass = 'section-' + section.title.toLowerCase()
                .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Supprimer les accents
                .replace(/[^a-z0-9]+/g, '-'); // Remplacer caractères spéciaux par tirets

            return `
            <div class="pdf-section-wrapper ${sectionClass}">
                <h2>${section.title}</h2>
                <div class="rte">${this.cleanContent(section.content)}</div>
            </div>
        `}).join('');

    const footerHtml = `
      <div class="legal-mentions-block">
        <div class="legal-company-name">OFIB</div>
        <div>28 rue Xavier Bichat – 72018 LE MANS</div>
        <div>Tél : 09 69 32 08 05 – expertofib@gmail.com – www.ofib.fr</div>
        <div>SAS au capital de 21 500 euros – RCS LE MANS</div>
        <div>N° SIREN : 479679193 – Code NAF : 8559A – TVA Intracommunautaire : FR08479679193</div>
        <div style="margin-top: 5px;">Organisme de formation enregistré sous le numéro 52 72 011107 72 auprès du Préfet de Région Pays de la Loire. Cet enregistrement ne vaut pas agrément de l’Etat.</div>
      </div>
    `;

    // 3. Construire le HTML complet
    const content = `
      <div class="pdf-container">
        
        <!-- Header -->
        <div class="pdf-header">
           <img src="${logo}" class="header-logo">
        </div>
        
        <h1 class="main-title">${title}</h1>
        <div class="reference-subtitle">RÉFÉRENCE : ${reference || '-'}</div>
        
        ${infosHtml}

        <div class="pdf-body">
          ${sectionsHtml}
        </div>

        ${footerHtml}
        
        <style>
          :root {
            --pdf-primary: #2c2e59;
            --pdf-font-stack: -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
            --pdf-text-main: #333333;
            --pdf-text-body: #444444;
            --pdf-text-muted: #666666;
            --pdf-text-light: #888888;
            --pdf-bg-white: #ffffff;
            --pdf-bg-light: #f8f9fa;
            --pdf-border: #e0e0e0;
            --pdf-border-light: #eeeeee;
          }

          * {
            box-sizing: border-box;
          }

          .pdf-container {
            font-family: var(--pdf-font-stack) !important;
            color: var(--pdf-text-main) !important;
            padding: 0 20px;
            margin: 0;
            background: var(--pdf-bg-white) !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            filter: none !important;
          }

          /* Header */
          .pdf-header {
            margin-bottom: 40px;
            border-bottom: 3px solid var(--pdf-primary) !important;
            padding-bottom: 20px;
          }
          .header-logo {
            max-width: 180px;
            max-height: 60px;
            width: auto;
            height: auto;
            object-fit: contain;
          }

          /* Main Title */
          .main-title {
            color: var(--pdf-primary) !important;
            margin: 0 0 10px 0;
            font-size: 28px;
            font-weight: 800;
            line-height: 1.2;
            text-transform: uppercase;
            font-family: var(--pdf-font-stack) !important;
          }

          /* Reference Subtitle */
          .reference-subtitle {
            font-size: 12px;
            font-weight: bold;
            color: var(--pdf-text-light) !important;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 40px;
            font-family: var(--pdf-font-stack) !important;
          }

          /* Info Card */
          .info-card {
            background-color: var(--pdf-bg-light) !important;
            padding: 20px;
            margin-bottom: 10px;
            border-radius: 8px;
            display: flex;
            justify-content: space-between;
            gap: 20px;
            border-left: 4px solid var(--pdf-primary) !important;
          }
          .price-disclaimer {
            font-size: 10px;
            color: var(--pdf-text-muted) !important;
            font-style: italic;
            margin-bottom: 40px;
          }
          .info-column {
            flex: 1;
          }
          .info-column.with-border {
            border-left: 1px solid var(--pdf-border) !important;
            padding-left: 20px;
          }
          .info-label {
            font-size: 11px;
            text-transform: uppercase;
            color: var(--pdf-text-muted) !important;
            margin-bottom: 4px;
            font-weight: bold;
            font-family: var(--pdf-font-stack) !important;
          }
          .info-value {
            font-size: 14px;
            color: var(--pdf-text-main) !important;
            font-family: var(--pdf-font-stack) !important;
          }
          .info-value.price {
            font-weight: bold;
            color: var(--pdf-primary) !important;
          }

          /* Sections */
          .pdf-section-wrapper {
            margin-bottom: 30px;
          }
          h2 { 
            color: var(--pdf-primary) !important; 
            font-size: 16px; 
            text-transform: uppercase; 
            letter-spacing: 1px; 
            border-bottom: 1px solid var(--pdf-border) !important; 
            padding-bottom: 10px; 
            margin-top: 30px; 
            margin-bottom: 15px; 
            page-break-after: avoid; 
            break-after: avoid;
            page-break-inside: avoid;
            font-family: var(--pdf-font-stack) !important;
          }
          .rte { 
            margin-bottom: 25px; 
            font-size: 13px; 
            line-height: 1.6; 
            color: var(--pdf-text-body) !important; 
            text-align: justify;
            font-family: var(--pdf-font-stack) !important;
            font-weight: 400 !important;
          }

          /* Footer */
          .legal-mentions-block {
            margin-top: 50px;
            padding-top: 20px;
            margin-bottom: 20px;
            border-top: 1px solid var(--pdf-border-light) !important;
            text-align: center;
            font-size: 10px;
            color: var(--pdf-text-muted) !important;
            line-height: 1.4;
            page-break-inside: avoid;
            break-inside: avoid;
            font-family: var(--pdf-font-stack) !important;
          }
          .legal-company-name {
            margin-bottom: 5px;
            font-size: 11px;
            color: var(--pdf-text-main) !important;
          }

          /* General Text */
          p, li { 
            font-size: 13px; 
            line-height: 1.6; 
            margin-bottom: 8px; 
            color: var(--pdf-text-body) !important; 
            font-family: var(--pdf-font-stack) !important;
            font-weight: 400 !important;
          }
          ul, ol { margin-bottom: 15px; padding-left: 25px; list-style-position: outside; }
          li { margin-bottom: 5px; padding-left: 5px; }
          
          /* Video Replacement */
          .video-replacement-card {
            margin: 20px 0;
            padding: 15px;
            background-color: var(--pdf-bg-light) !important;
            border: 1px solid var(--pdf-border) !important;
            border-radius: 4px !important;
            text-align: center !important;
          }
          .video-replacement-link {
            color: var(--pdf-text-main) !important;
            text-decoration: none !important;
            font-weight: bold !important;
            font-size: 13px !important;
          }

          /* Empêcher les coupures au milieu des lignes */
          p, li, h1, h3, h4, h5, h6 {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          /* Règle générale : Toutes les sections doivent rester groupées si possible */
          .pdf-section-wrapper:not(.section-description) {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
            display: block;
          }

          /* La description a le droit de se couper sur plusieurs pages */
          .section-description {
            page-break-inside: auto !important;
            break-inside: auto !important;
          }
        </style>
      </div>
    `;

    // 4. Configuration et génération
    const filename = (title ? title.trim() : "formation") + ".pdf";
    const opt = {
        margin: [15, 15, 20, 18], 
        filename: filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
            scale: 2, 
            letterRendering: true,
            useCORS: true,
            scrollY: 0,
            backgroundColor: '#ffffff'
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { 
            mode: 'css',
            avoid: '.legal-mentions-block' 
        }
    };

    try {
        await html2pdf().set(opt).from(content, 'string').save();
    } catch (error) {
        alert("Une erreur est survenue lors de la génération.");
    }
  }
}

if (!customElements.get('programme-pdf')) {
  customElements.define('programme-pdf', ProgrammePdf);
}
